import React from 'react';
import { useParams } from 'react-router-dom';
import { RobbieUiProvider } from '../../contexts/RobbieUiContext';
import RFQWizard, { RFQWizardProps } from '../RFQWizard';

/**
 * The route's entry point. The provider wraps the page, not the page's JSX:
 * `useWizardRobbie` (the conversation) and the navigation recorder both run in
 * the page, and a hook can only reach a provider that sits above the
 * component calling it.
 */
const RFQWizardRoute: React.FC<RFQWizardProps> = (props) => {
  const { rfqId = '' } = useParams<{ rfqId: string }>();
  return (
    <RobbieUiProvider rfqId={rfqId}>
      <RFQWizard {...props} />
    </RobbieUiProvider>
  );
};

export default RFQWizardRoute;
